/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UserConfigurationDto } from '../../models/user-configuration-dto';

export interface GetUserConfiguration$Params {
}

export function getUserConfiguration(http: HttpClient, rootUrl: string, params?: GetUserConfiguration$Params, context?: HttpContext): Observable<StrictHttpResponse<UserConfigurationDto>> {
  const rb = new RequestBuilder(rootUrl, getUserConfiguration.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UserConfigurationDto>;
    })
  );
}

getUserConfiguration.PATH = '/v0/userConfigurations';
